function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDj = function SvgDj(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 10"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v10H0z",
    style: {
      fill: "#6ab2e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5h15v5H0z",
    style: {
      fill: "#12ad2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v10l4.33-2.5L8.66 5 4.33 2.5z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.314 3.75.31.955H4.63l-.813.59.31.955-.812-.59-.812.59.31-.955L2 4.705h1.004z",
    style: {
      fill: "#d7141a"
    }
  }));
};
export default SvgDj;